import { InitPasswordReset, ConfirmPasswordReset, ResendActivationEmail } \
  from 'alto-react-base-auth/lib/components'

import ClientLogin                           from './components/login/main'
import Profile                               from './components/profile/main'
import AuthMessage                           from './components/auth_message'
import ContactForm, { IfContactFormEnabled } from './components/contact_form'
import CardNumberForm                        from './components/registration/card_number_form'
import ClientAuthUserBar                     from './components/user_bar'
import ChangePasswordPanel                   from './components/profile/change_password_panel'
import LoginCredentialsForm                  from './components/registration/login_credentials_form'
import LoginCredentialsFormWithBV            from './components/registration/login_credentials_form_with_bv'
import LoginCredentialsFormWithoutBV         from './components/registration/login_credentials_form_without_bv'

export { ClientLogin, Profile, ClientAuthUserBar, AuthMessage, \
         ContactForm, IfContactFormEnabled, ChangePasswordPanel, \
         InitPasswordReset, ConfirmPasswordReset, ResendActivationEmail, CardNumberForm, \
         LoginCredentialsForm, LoginCredentialsFormWithBV, LoginCredentialsFormWithoutBV }
